<template>
  <div class="layout-container page-main">
    <div class="page-panel">
      <div class="page-head">
        <h1>观看历史</h1>
        <button v-if="watchList.length" class="btn-danger" @click="clearHistory">清空历史</button>
      </div>

      <div v-if="watchList.length" class="list-panel">
        <div v-for="item in watchList" :key="item.id" class="list-row">
          <img class="cover cover-portrait" :src="getCover(item)" alt="" @error="onCoverError"/>
          <div class="row-body">
            <div class="row-title">{{ item.title }}</div>
            <div class="row-sub">上次观看：{{ formatTime(item.createTime) }}</div>
          </div>
          <div class="row-action">
            <router-link :to="{ path: '/videoInfo', query: { id: item.vsId, vaId: item.vaId } }">
              <button class="btn-primary">继续观看</button>
            </router-link>
          </div>
        </div>
      </div>

      <div v-else class="empty-state">暂无观看记录</div>

      <PagerBar
          v-if="totalPages > 1"
          :page="pageNum"
          :total="totalPages"
          @change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { getWatchHistoryList, deleteWatchHistory } from '@/utils/http'
import { getVideoCover, handleCoverError } from '@/utils/cover'
import PagerBar from '@/components/PagerBar.vue'

export default {
  name: 'WatchHistory',
  components: { PagerBar },
  data() {
    return {
      watchList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const res = await getWatchHistoryList({ pageSize: this.pageSize, pageNum: this.pageNum })
      this.watchList = res.data || []
      this.total = res.total || 0
    },
    changePage(p) {
      if (p < 1 || p > this.totalPages || p === this.pageNum) return
      this.pageNum = p
      this.init()
    },
    async clearHistory() {
      if (confirm('确定清空全部观看历史？')) {
        await deleteWatchHistory()
        this.watchList = []
        this.pageNum = 1
        this.total = 0
      }
    },
    formatTime(time) {
      if (!time) return ''
      const d = new Date(time)
      const pad = n => (n < 10 ? '0' + n : n)
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    getCover(item) {
      return getVideoCover(item)
    },
    onCoverError(e) {
      handleCoverError(e)
    }
  }
}
</script>
